import React from "react";
import { graphql, useStaticQuery, withPrefix } from "gatsby";
import classNames from "classnames";
import ReactTooltip from "react-tooltip";
import Parser from "html-react-parser";
import CircleInfo from "../icons/circle-info-light.svg";
import { formatPrice } from "../utility/prices";

const ProductPrice = ({ data, compare, contributoRaee }) => {
  const pathPrefix = withPrefix("/");
  const {
    site: {
      siteMetadata: { priceLanguage },
    },
    config: { priceInPerc, priceWithWeee, labelDiscountYes },
    labelManagerLabels,
    productNote,
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          priceLanguage
        }
      }
      config: liferayGeneralConfiguration {
        priceInPerc
        priceWithWeee
        labelDiscountYes
      }
      labelManagerLabels {
        pricePercentageTooltip
        priceAbsoluteTooltip
        labelDiscountYes
        msrpLabel
        suggestedPriceInfo
      }
      productNote: liferayProductNotes {
        ...ProductNotesFragment
      }
    }
  `);

  const isDiscount =
    data?.sellingPrice?.value &&
    ((data?.omnibusPrice?.value && data.sellingPrice.value < data.omnibusPrice.value) ||
      (!data?.omnibusPrice?.value &&
        data?.msrpPrice?.value &&
        data.sellingPrice.value < data.msrpPrice.value));
  const isPercAndAbsolute = priceInPerc === "perc and absolute";
  const labelDiscount = labelDiscountYes;

  return (
    <div>
      <div
        className={classNames(
          "product-price d-flex justify-content-center align-items-center",
          (isDiscount || data?.sellingPrice?.value < data?.msrpPrice?.value) && "flex-column",
          //isDiscount && !isPercAndAbsolute && "flex-sm-row",
          compare && "product-price--compare"
        )}
      >
        {data !== undefined ? (
          <div
            className={classNames(
              isDiscount && isPercAndAbsolute && "d-flex pt-2",
              compare && "flex-column flex-sm-row",
              isDiscount &&
                isPercAndAbsolute &&
                (compare ? "align-items-start align-items-sm-center" : "align-items-center")
            )}
          >
            <div
              className={classNames(
                "product-price__current",
                isDiscount && isPercAndAbsolute ? "p-0" : "py-2"
              )}
            >
              {data ? (
                <>
                  {formatPrice(data.sellingPrice?.value, data.sellingPrice.currency, priceLanguage)}
                  {!!productNote && productNote.textPopUp !== "" && "*"}
                </>
              ) : (
                <div className="pt-2"></div>
              )}
            </div>
            {isDiscount && isPercAndAbsolute ? (
              <span className="product-price__original mr-2 mr-sm-3 ml-3">
                {formatPrice(
                  data?.omnibusPrice?.value ? data.omnibusPrice.value : data.msrpPrice.value,
                  data.sellingPrice.currency,
                  priceLanguage
                )}
              </span>
            ) : null}
          </div>
        ) : null}
        {data ? (
          isDiscount ? (
            <div
              className={classNames(
                "d-inline-flex align-items-center",
                !isPercAndAbsolute && "ml-3"
              )}
            >
              {!isPercAndAbsolute ? (
                <span className="product-price__original mr-2 mr-sm-3">
                  {formatPrice(
                    data?.omnibusPrice?.value ? data.omnibusPrice.value : data.msrpPrice.value,
                    data.sellingPrice.currency,
                    priceLanguage
                  )}
                </span>
              ) : null}

              <span className="product-price__saving d-inline-flex align-items-center">
                {priceInPerc === "only perc" ? (
                  <>
                    <PricePerc
                      priceLanguage={priceLanguage}
                      data={data}
                      priceWithWeee={priceWithWeee}
                      contributoRaee={contributoRaee}
                    />
                    {labelManagerLabels?.pricePercentageTooltip && (
                      <>
                        <p data-for="priceInPercInfo" data-tip>
                          <CircleInfo className="product-price__icon" />
                        </p>
                        <ReactTooltip
                          id="priceInPercInfo"
                          place="top"
                          effect="float"
                          textColor="#505456"
                          type="light"
                        >
                          <CircleInfo className="product-price__icon product-price__icon--tooltip" />{" "}
                          {Parser(labelManagerLabels?.pricePercentageTooltip)}
                        </ReactTooltip>
                      </>
                    )}
                  </>
                ) : isPercAndAbsolute ? (
                  <>
                    <span className="mr-2">
                      <PriceAbs
                        priceLanguage={priceLanguage}
                        data={data}
                        priceWithWeee={priceWithWeee}
                        contributoRaee={contributoRaee}
                        save={
                          !!labelDiscount && !!labelManagerLabels.labelDiscountYes ? true : false
                        }
                        labelDiscount={labelManagerLabels.labelDiscountYes}
                      />
                    </span>
                    <span>
                      {"("}
                      <PricePerc
                        priceLanguage={priceLanguage}
                        data={data}
                        priceWithWeee={priceWithWeee}
                        contributoRaee={contributoRaee}
                      />
                      {")"}
                    </span>
                    {labelManagerLabels?.pricePercentageTooltip && (
                      <>
                        <p className="mb-1" data-for="isPercAndAbsoluteInfo" data-tip>
                          <CircleInfo className="product-price__icon" />
                        </p>
                        <ReactTooltip
                          id="isPercAndAbsoluteInfo"
                          place="top"
                          effect="float"
                          textColor="#505456"
                          type="light"
                        >
                          <CircleInfo className="product-price__icon product-price__icon--tooltip" />{" "}
                          {Parser(labelManagerLabels?.pricePercentageTooltip)}
                        </ReactTooltip>
                      </>
                    )}
                  </>
                ) : priceInPerc === "only abs" ? (
                  <>
                    <PriceAbs
                      priceLanguage={priceLanguage}
                      data={data}
                      priceWithWeee={priceWithWeee}
                      contributoRaee={contributoRaee}
                      save={!!labelDiscount && !!labelManagerLabels.labelDiscountYes ? true : false}
                      labelDiscount={labelManagerLabels.labelDiscountYes}
                    />
                    {labelManagerLabels?.priceAbsoluteTooltip && (
                      <>
                        <p
                          className="product-detail__priceInfo"
                          data-for="productPriceInfo"
                          data-tip
                        >
                          <CircleInfo className="product-price__icon" />
                        </p>
                        <ReactTooltip
                          id="productPriceInfo"
                          place="top"
                          effect="solid"
                          textColor="#505456"
                          type="light"
                        >
                          <CircleInfo className="product-price__icon product-price__icon--tooltip" />
                          {Parser(labelManagerLabels?.priceAbsoluteTooltip)}
                        </ReactTooltip>
                      </>
                    )}
                  </>
                ) : null}
              </span>
            </div>
          ) : null
        ) : data === null ? (
          <div className="py-3 mt-md-1"></div>
        ) : (
          <div className="py-3 mt-md-1"></div> // TODO loading
        )}
        {data?.msrpPrice?.value &&
          data?.msrpPrice?.value !== "0.0" &&
          data?.msrpPrice?.value > data?.sellingPrice?.value &&
          data?.omnibusPrice?.value &&
          data?.msrpPrice?.value > data?.omnibusPrice?.value &&
          pathPrefix !== "/cs_CZ/" && (
            <div className="d-flex product-detail__msrp">
              <div>
                {`${labelManagerLabels?.msrpLabel}: `}
                {formatPrice(data.msrpPrice.value, data.sellingPrice.currency, priceLanguage)}
              </div>
              {labelManagerLabels?.suggestedPriceInfo && (
                <>
                  <p className="product-detail__priceInfo" data-for="productMsrpPriceInfo" data-tip>
                    <CircleInfo className="product-price__icon product-price__icon--msrp" />
                  </p>
                  <ReactTooltip
                    id="productMsrpPriceInfo"
                    place="top"
                    effect="solid"
                    textColor="#979797"
                    type="light"
                  >
                    <CircleInfo className="product-price__icon product-price__icon--msrp product-price__icon--tooltip" />
                    {Parser(labelManagerLabels?.suggestedPriceInfo)}
                  </ReactTooltip>
                </>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

const parseRaee = (contributoRaee) =>
  parseFloat(contributoRaee?.replace(/[^0-9,.]/g, "")?.replace(/[^0-9]/g, "."))?.toFixed(2);

const PriceFormatted = ({ priceLanguage, priceValue, currency, save, labelDiscount, origin }) => {
  const options = currency ? { style: "currency", currency } : { style: "percent" };
  const formatted =
    currency && priceLanguage === "tr-TR"
      ? formatPrice(priceValue, currency, priceLanguage)
      : Intl.NumberFormat(priceLanguage, options).format(priceValue);
  return (!save ? "-" : save && origin === "tag" ? "" : `${labelDiscount} `) + formatted.toString();
};

export const PricePerc = ({
  priceLanguage,
  data,
  save,
  priceWithWeee,
  contributoRaee,
  labelDiscount,
  origin,
}) => {
  const contributoRaeeFormatted = contributoRaee ? parseRaee(contributoRaee) : null;
  const priceValue =
    priceWithWeee === "yes" && contributoRaee
      ? (data.msrpPrice.value - data.sellingPrice.value) /
        (data.msrpPrice.value - contributoRaeeFormatted)
      : (data.msrpPrice.value - data.sellingPrice.value) / data.msrpPrice.value;
  const priceValueOmnibus = data?.omnibusPrice?.value
    ? priceWithWeee === "yes" && contributoRaee
      ? (data.omnibusPrice.value - data.sellingPrice.value) /
        (data.omnibusPrice.value - contributoRaeeFormatted)
      : (data.omnibusPrice.value - data.sellingPrice.value) / data.omnibusPrice.value
    : null;
  return (
    <PriceFormatted
      priceLanguage={priceLanguage}
      priceValue={data?.omnibusPrice?.value ? priceValueOmnibus : priceValue}
      save={save}
      labelDiscount={labelDiscount}
      origin={origin}
    />
  );
};

export const PriceAbs = ({ priceLanguage, data, save, labelDiscount, origin }) => {
  const priceValue = data?.omnibusPrice?.value
    ? data.omnibusPrice.value - data.sellingPrice.value
    : data.msrpPrice.value - data.sellingPrice.value;
  return (
    <PriceFormatted
      priceLanguage={priceLanguage}
      priceValue={priceValue}
      save={save}
      currency={data.sellingPrice.currency}
      labelDiscount={labelDiscount}
      origin={origin}
    />
  );
};

export default ProductPrice;
